<template>
  <!-- <div v-if="from === 'chat' || from === 'zahnarzt'" class="ion-text-center"> -->
  <!-- <img src="@/assets/img/ztk_logo.svg" width="200" /> -->
  <!-- <img
    class="u-rounded u-bg-orange"
    src="@/assets/img/content/icon_dentist.svg"
  /> -->
  <!-- <div
    class="c-header u-bg-orange -contain-bottom"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/content/icon_dentist.svg') + ')',
    }"
  >
    <img class="c-header__logo" src="@/assets/img/ztk_logo.svg" width="110" />
  </div> -->
  <Header
    class="u-bg-orange -contain-bottom"
    headline="Ihr Lachen ist unser Anliegen."
    :image="require('@/assets/img/content/icon_dentist.svg')"
    :logo="require('@/assets/img/ztk_logo.svg')"
    logoWidth="210"
    hideButton
  />
  <!-- </div> -->
  <!-- <div
    v-else
    class="c-header"
    :style="{
      'background-image':
        'url(' + require('@/assets/img/slider/slider_tagesklinik.svg') + ')',
    }"
  >
    <img src="@/assets/img/ztk_logo.svg" width="200" />
    <div class="c-header__text u-small">
      Beste zahnmedizinische Versorgung – 14 x im Süden Deutschlands! Modernste
      Ausstattung, individuell auf Sie abgestimmte Behandlungskonzepte, und am
      wichtigsten: ein freundliches und kompetentes Team.
    </div>
  </div> -->
  <div class="ion-margin-top ion-margin-bottom">
    <template v-if="from === 'chat'">
      <p class="ion-padding-top ion-hide-lg-up">
        <b>Ihr Lachen ist unser Anliegen.</b>
      </p>
      <p>
        Beste zahnmedizinische Versorgung – 14 x im Süden Deutschlands!<br />
        Modernste Ausstattung, individuell auf Sie abgestimmte
        Behandlungskonzepte, und am wichtigsten: ein freundliches und
        kompetentes Team.
      </p>
    </template>
    <b>Ihre exklusiven Vorteile als ARAG Versicherter:</b>
    <ul>
      <li>
        Mehr Sicherheit für Sie: Holen Sie eine unabhängige Zweitmeinung ein
      </li>
      <li>
        Sie brauchen sich um nichts kümmern: Behandlungen und professionelle
        Zahnreinigung werden direkt mit der ARAG abgerechnet. Ihre Vorleistung
        entfällt.
      </li>
      <li>
        Schnelle Termine mit langen Öffnungszeiten, auch samstags
      </li>
      <li>Deutsche Markenqualität bei allen Laborleistungen</li>
    </ul>
    <!-- <ul>
      <li>Schneller Termin</li>
      <li>Einholung einer unabhängigen Zweitmeinung (ohne Behandlungszwang)</li>
      <li>Direkte Weiterleitung des Heil- und Kostenplans an die ARAG</li>
      <li>Direkte Abrechnung der professionellen Zahnreinigung</li>
      <li>
        Direkte Abrechnung zwischen den Zahnärztlichen Tageskliniken und ARAG
      </li>
      <li>
        Direkte Kommunikation zwischen den Zahnärztlichen Tageskliniken und ARAG
        bei Abrechnungsstreitigkeiten
      </li>
    </ul> -->
  </div>
  <!-- <div class="ion-margin-top ion-margin-bottom">
    <b>Exklusive Service-Qualität</b>
    <ul>
      <li>Lange Öffnungszeiten</li>
      <li>Auch samstags für Sie geöffnet</li>
      <li>Deutsche Markenqualität bei Laborleistungen</li>
    </ul>
  </div> -->
  <div class="c-line"></div>
  <p>
    <b>Spezialisierungen:</b>
    <!-- <br />
    <SpezialisierungenZTK /> -->
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_implantologie.svg')"
        />
      </ion-col>
      <ion-col>
        Implantologie
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_parodontologie.svg')"
        />
      </ion-col>
      <ion-col>
        Parodontologie
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_zahnheilkunde.svg')"
        />
      </ion-col>
      <ion-col>
        Ästhetische Zahnheilkunde
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_zahnersatz.svg')"
        />
      </ion-col>
      <ion-col>
        Hochwertiger Zahnersatz
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_kieferchirugie.svg')"
        />
      </ion-col>
      <ion-col>
        Zahnärztliche Kieferchirurgie, u.v.m.
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_zahnbehandlung.svg')"
        />
      </ion-col>
      <ion-col>
        Digitales Röntgen
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row class="ion-align-items-center">
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_profi_zahnreinigung.svg')"
        />
      </ion-col>
      <ion-col>
        Spezielle Parodontitis-Sprechstunde
      </ion-col>
    </ion-row>
  </p>

  <ion-button
    size="small"
    fill="clear"
    class="ion-text-wrap ion-no-padding"
    @click="openKostenerstattungModal"
    >Kostenlos für ARAG-Kunden mit Vollversicherung!&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button>
</template>

<script>
import {
  modalController,
  IonButton,
  IonIcon,
  IonCol,
  IonRow,
} from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@/components/KostenerstattungZTKModal";
import Header from "@/components/Header";
// import SpezialisierungenZTK from "@/components/SpezialisierungenZTK";

export default {
  components: {
    IonButton,
    IonIcon,
    IonCol,
    IonRow,
    Header,
    // SpezialisierungenZTK,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
